/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Setting_Online_DescInputs */



/**
* | output |
* | --- |
* | "Played over Discord or another online venue." |
*
* @param {Tournament_Wiz_Setting_Online_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_setting_online_desc = /** @type {((inputs?: Tournament_Wiz_Setting_Online_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Setting_Online_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joué sur Discord ou dans un autre lieu en ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se juega en Discord o en otra sede en línea.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogado pelo Discord ou em outro local online.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si gioca su Discord o in un'altra sede online.")
	return /** @type {LocalizedString} */ ("Played over Discord or another online venue.")
});